module.exports = __webpack_public_path__ + "img/megaphone.7eefa8a0.png";